// extracted by mini-css-extract-plugin
export default {"controlPanel":"ControlPanel_controlPanel__xsPXE","label":"ControlPanel_label__u1d8k"};